import { WButton, WIcon, WParagraph } from '@alice-health/wonderland-react'
import classNames from 'classnames'

interface ScrollToTopMessageProps {
  constrainWidth?: boolean
  showScrollButton?: boolean
}

const ScrollToTopMessage = ({
  constrainWidth = true,
  showScrollButton = true
}: ScrollToTopMessageProps) => {
  const handleScrollToTopButton = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <div className='px-20 pt-16 pb-28 lg:py-20 flex flex-col items-center gap-gl-spacing-06'>
      <WIcon
        className='text-gl-color-shades-magenta-60'
        icon='icCheckOutlined'
        size='xlarge'
      />

      <WParagraph
        className={classNames('text-center', constrainWidth && 'max-w-[190px]')}
        variant='heavy'
        size='large'
        mode='primary'
      >
        Isso é tudo! Chegamos ao fim da nossa lista
      </WParagraph>

      {showScrollButton ? (
        <WButton
          size='medium'
          icon='icArrowUp'
          onClick={handleScrollToTopButton}
        >
          Voltar para o topo
        </WButton>
      ) : null}
    </div>
  )
}

export { ScrollToTopMessage }
export type { ScrollToTopMessageProps }
